// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"fixed-right-bottom__wrap--10Lii"};